import styled from 'styled-components';

export const StyledHudButton = styled.button`
  border: none;
  color: ${({ theme }) => theme.primaryLight};
  background: ${({ theme }) => theme.hudButtonLight};
  width: 100%;
  height: 8vh;
  padding: 5px 5px;
  margin: 10px 0px;
  cursor: pointer;

  .content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding: 5px;
    gap: 10px;
    font-size: 20px;
    text-transform: uppercase;

    img {
      height: 100%;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
  }

  &:hover {
    background: ${({ theme }) => theme.hudButtonHover};
  }
`;
